import React from 'react'

const Services = () => {
  return (
<div className="content-section" id="services">
                <h2>Our Services</h2>
                <div className="services-columns">
                    <div className="services-column">
                        <h3>For Hospitals</h3>
                        <p>At PulseInnovas, we specialize in transforming traditional hospitals into AI-assisted healthcare environments by seamlessly integrating advanced technologies across OPD, IPD, ICUs, and Operating Theaters. Our intelligent solutions streamline workflows, automate documentation, and employ predictive analytics to help clinicians make data-driven decisions </p>
                    </div>
                    <div className="services-column">
                        <h3>For Space Companies</h3>
                        <p>We loan out our AI medical care API to customers on a contract basis. Our AI is trained in space medical data to handle medical conditions in space and deep space (Moon and Mars).</p>
                    </div>
                </div>
            </div>  )
}

export default Services